<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
      <div>
        <UpdateDialog 
       v-if ="isUpdateDialogActive" 
      :is-active="isUpdateDialogActive"
      :versionno="latestVersion"
      @update-confirmed="updateApp"
      @update-cancelled="cancelUpdate"      
      />
        <v-layout row v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <Appalert
              @dismissed="onDismissed"
              :alerttext="error.message"
            ></Appalert>
          </v-flex>
        </v-layout>
        <v-tabs
         
          v-model="tab"
          show-arrows
          background-color=""
          icons-and-text
          grow
        >
         <!-- v-if ="!isUpdateDialogActive" -->
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab v-for="i in tabs" :key="i.name">
            <v-icon large>{{ i.icon }}</v-icon>
            <div class="caption py-1">{{ i.name }}</div>
          </v-tab>
          <v-tab-item>
            <v-card class="px-4">
              <v-card-text>
                <v-form ref="loginForm" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model.trim="loginEmail"
                        :rules="loginEmailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="loginPassword"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="6" xsm="12"> </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                      <v-btn
                        x-large
                        block
                        :disabled="!valid || loading"
                        :loading="loading"
                        color="primary"
                        @click="onSignin"
                      >
                        Login
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="px-4">
              <v-card-text>
                <v-form ref="registerForm" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="firstName"
                        :rules="[rules.required]"
                        label="First Name"
                        maxlength="20"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="lastName"
                        :rules="[rules.required]"
                        label="Last Name"
                        maxlength="20"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :items="companies"
                        solo
                        v-model="selectedcompany"
                        label="Company"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        block
                        v-model="verify"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, passwordMatch]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex ml-auto" cols="12" sm="3" xsm="12">
                      <v-btn
                        x-large
                        block
                        :disabled="!valid || loading"
                        :loading="loading"
                        color="primary"
                        @click="onSignup"
                        >Register</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-dialog>
    <v-dialog v-model="showPop" max-width="290">
      <Popup />
    </v-dialog>
    
  </div>
</template>

<script>
import Appalert from "../components/Alert";
import Popup from "@/components/Popup";
import UpdateDialog from "../components/UpdateDialog";
import { APP_VERSION } from '@/version.js';
import secure_axios from "../services/secure_axios";


export default {
  components: {
    Appalert,
    Popup,
    UpdateDialog,
  },
  computed: {
    showPop() {
      return this.$store.getters.showPop;
    },

    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    },

    user() {
      return this.$store.getters.factsuser;
    },

    error() {
      return this.$store.getters.error;
    },

    loading() {
      return this.$store.getters.loading;
    },
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push("/home");
      }
    },
  },

  methods: {
    onSignin() {
      this.$store.dispatch("signUserIn", {
        email: this.loginEmail,
        password: this.loginPassword,
      });
    },

    onSignup() {
      this.$store.dispatch("signUserUp", {
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        company: this.selectedcompany,
      });
    },

    onDismissed() {
      this.$store.dispatch("getClearError");
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
    checkForUpdate() {
      secure_axios.get('https://tritonfactsapi.ngrok.io/version')
        .then(response => {
          console.log(response.data.version)
          const versionNumber =  response.data.version;
          // this.checkServiceworker()
          // Compare the version number with the current app's version
           if (versionNumber !== APP_VERSION) {
          // If an update is available, show the update dialog
          this.isUpdateDialogActive = true;
          this.latestVersion = versionNumber; 
          }
        })
        .catch(error => {
         console.error('Error fetching version number:', error);
      });
    },
    checkServiceworker(){
      if ('serviceWorker' in navigator) {
        // Check if a service worker is already registered
        navigator.serviceWorker.getRegistration()
          .then(function(registration) {
            if (registration) {
              console.log('Service worker already registered');
            } else {
              // If no service worker is registered, register a new one
              navigator.serviceWorker.register('/service-worker.js')
                .then(function(registration) {
                  console.log('Service worker registered:', registration);
                })
                .catch(function(error) {
                  console.log('Service worker registration failed:', error);
                });
            }
          });
      } else {
        console.log('Service workers are not supported.');
      }
    },
    updateApp() {
      // Perform update action
      // this.$sw.update().then(() => {
      // this.$sw.send({ action: 'skipWaiting' });
      window.location.reload();
    //  });
      // After the update is completed, reload the app to load the updated version
      // window.location.reload();
    },
    cancelUpdate() {
      this.isUpdateDialogActive = false;
    }  
  }, 
  data: () => ({
    dialog: true,
    tab: 0,
    tabs: [
      { name: "Login", icon: "mdi-account" },
      { name: "Register", icon: "mdi-account-outline" },
    ],
    companies: ['Skymat', 'Triton'],
    selectedcompany: "",
    valid: true,
    msgdialog: false,
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    verify: "",
    loginPassword: "",
    loginEmail: "",
    loginEmailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v)|| "E-mail must be valid",
    ],
    emailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    show1: false,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
    },
    isUpdateDialogActive: false,
    latestVersion: ''
  }),
  mounted() {
    // Check for update when the app is mounted
    // this.checkForUpdate();
    // this.$store.dispatch("getclearError");
    this.$store.dispatch("getLoading",false);
  },
  beforeMount() {
    // Code to be executed before the component is mounted
    this.$store.dispatch("getLoading",false)
  },
};
</script>
